import React from "react";

// Exact excerpts verified on Google Maps on 2026-09-16. Translations are labelled.
export const reviews = [
  {
    name: "Mariia Davidovich",
    original: "en",
    url: "https://maps.app.goo.gl/UiGn4PcEt3doPvUj8",
    en: "They're not overly sweet, the flavors are perfectly balanced, and the glaze has an incredibly satisfying crunch.",
    el: "Δεν είναι υπερβολικά γλυκά, οι γεύσεις είναι τέλεια ισορροπημένες και η επικάλυψη έχει μια απίστευτα απολαυστική τραγανότητα.",
  },
  {
    name: "Νίνα",
    original: "el",
    url: "https://maps.app.goo.gl/fZ9dHsKapmxoyBGM8",
    el: "Τα γλυκά τους είναι υπέροχα! Φρέσκα, νόστιμα και φτιαγμένα με ποιοτικά υλικά.",
    en: "Their desserts are wonderful! Fresh, delicious and made with quality ingredients.",
  },
  {
    name: "ΑΝΔΡΕΑΣ ΑΤΤΟΥΝΑ",
    original: "el",
    url: "https://maps.app.goo.gl/Gzk4c9BVEPM5exm17",
    el: "Όλα ηταν πανέμορφα!!! Δεν εχω λογια!! Άψογη εξυπηρέτηση.. τα γλυκά πεντανοστιμα!! Ο χώρος πολύ όμορφος..",
    en: "Everything was beautiful!!! I have no words!! Impeccable service.. the desserts were delicious!! The space was very beautiful..",
  },
];
export default function Reviews({ c, language }) {
  return (
    <section
      className="reviews section-wrap"
      id="testimonials"
      aria-labelledby="reviews-title"
    >
      <div className="section-heading">
        <div>
          <p className="eyebrow">01 / {c.reviewsLabel}</p>
          <h2 id="reviews-title">
            {c.reviewsTitle}
            <br />
            <em>{c.reviewsAccent}</em>
          </h2>
        </div>
        <a
          className="text-link"
          href="https://www.google.com/maps/search/?api=1&query=Maya%27s+Flavours+Latsia"
          target="_blank"
          rel="noreferrer"
        >
          {c.googleReviews} ↗
        </a>
      </div>
      <p className="review-source-label">{c.selectedReviews}</p>
      <div className="review-grid">
        {reviews.map((review) => (
          <article className="review-card" key={review.name}>
            <div
              className="review-stars"
              aria-label={
                language === "el" ? "5 από 5 αστέρια" : "5 out of 5 stars"
              }
            >
              ★★★★★
            </div>
            <blockquote>“{review[language]}”</blockquote>
            <div className="review-author">
              <span className="review-avatar" aria-hidden="true">
                {review.name.slice(0, 1)}
              </span>
              <div>
                <h3>{review.name}</h3>
                <a href={review.url} target="_blank" rel="noreferrer">
                  Google · {c.readReview} ↗
                </a>
              </div>
            </div>
            {language !== review.original && (
              <p className="translation-note">
                {review.original === "el" ? c.translated : c.translatedEnglish}
              </p>
            )}
          </article>
        ))}
      </div>
      <p className="review-date">{c.reviewed}</p>
    </section>
  );
}
